const TAB_ANCHOR_PATTERN = /^#tab-.+-(\d+)$/;

// The legacy site numbered the subject tabs from zero, and the three
// jumppoints in circulation (e.g. #tab-491089-0) are Mathe, Deutsch and
// Englisch. Any other number is not a deep-link target we promise to honour.
const NUMBER_TO_SUBJECT_NAME: Record<number, string> = {
  0: 'Mathe',
  1: 'Deutsch',
  2: 'Englisch',
};

// Readable anchors for the same three tabs, for links written by hand.
// Deliberately a fixed list rather than every subject's name: these are the
// three an editor may link to.
const NAME_ANCHOR_TO_SUBJECT_NAME: Record<string, string> = {
  mathe: 'Mathe',
  deutsch: 'Deutsch',
  englisch: 'Englisch',
};

export const resolveSubjectNameForTabAnchor = (hash: string): string | null => {
  const match = TAB_ANCHOR_PATTERN.exec(hash);
  if (match) {
    return NUMBER_TO_SUBJECT_NAME[Number(match[1])] ?? null;
  }
  if (!hash.startsWith('#')) {
    return null;
  }
  return NAME_ANCHOR_TO_SUBJECT_NAME[hash.slice(1).toLowerCase()] ?? null;
};
